module.exports = __webpack_public_path__ + "static/media/ojttio.37b5f294.jpg";